import {
  all, call, put, takeEvery, takeLatest,
} from 'redux-saga/effects';
import {
  saveCashierGeneralSettings,
  saveCashierBrandSettings,
} from 'actions/cashier/cashierActionCreator';
import {
  changeLoadingState, setSuccessMessage, setErrorMessage, changeEndedStatus,
} from 'app/settings/slices';
import NetworkService from 'services/networkService';
import CashierActionType from 'actions/cashier/cashierActionType';
import { i18n } from 'services';
import { AppConstants } from 'constants/index';
import { getError, getMessage } from 'utils/helpers';
import { isJSON } from 'utils/utils';

function* getCashierSettings({ payload }) {
  try {
    const { brandId } = payload;
    const { BrandAdmin, GeneralSetting, CashierSetting } = AppConstants.api;
    yield put(changeLoadingState(true));
    const { data } = yield call(NetworkService.makeAPIGetRequest, [BrandAdmin, GeneralSetting, CashierSetting, brandId]);
    yield put(brandId ? saveCashierBrandSettings(data) : saveCashierGeneralSettings(data));
    yield put(changeLoadingState(false));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

function* editCashierGeneralSettings({ payload }) {
  try {
    const { brandId, data } = payload;
    yield put(changeLoadingState(true));
    const { BrandAdmin, GeneralSetting, CashierSetting } = AppConstants.api;
    yield call(NetworkService.makeAPIPutRequest, [BrandAdmin, GeneralSetting, CashierSetting, brandId], { data });
    yield put(changeEndedStatus(true));
    yield put(setSuccessMessage(getMessage(i18n.t('cms:cashierSettings'), i18n.t('notification:plUpdated'))));
    yield put(changeLoadingState(false));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

export default function* cashierSaga() {
  yield all([
    takeEvery(CashierActionType.GET_CASHIER_SETTINGS, getCashierSettings),
    takeLatest(CashierActionType.EDIT_CASHIER_GENERAL_SETTINGS, editCashierGeneralSettings),
  ]);
}
